import React from "react";
import {ChipLabel} from "./index";

const AddressChangeSourceChip = ({source}) => {
    const sourceData = {
        "manual": {
            class: "status-chip warning",
            text: "Manual"
        },
        "algorithm": {
            class: "status-chip none",
            text: "Algorithm"
        },
        "smarty": {
            class: "status-chip secondary",
            text: "Smarty"
        }
    }

    return (<ChipLabel label={sourceData[source]?.text} className={sourceData[source]?.class}/>)
}

export default AddressChangeSourceChip;
